import { Navigate, useParams } from "react-router-dom";

/** MCP / Agent lives under Settings — keep this route as a real redirect. */
export function McpPage() {
  const { orgSlug, projectSlug } = useParams();
  return <Navigate to={`/o/${orgSlug}/p/${projectSlug}/settings/mcp`} replace />;
}
